<a href="{{ item[element.key] }}" target="_blank" *ngIf="element.type == 'link'">{{
    item[element.key] }}</a>
<button *ngIf="element.type == 'button' &&  item[element.key] != '---'" class="{{ element.class }}"
    (click)="element.onClick(item)"><i class="fa fa-link" aria-hidden="true"></i> {{
    item[element.key] }}</button>
<span *ngIf="element.type == 'button' &&  item[element.key] == '---'">{{ item[element.key] }}</span>
<span *ngIf="element.type == 'text'" class="{{ element.class }}" data-toggle="tooltip" data-placement="bottom"
    title="{{ (element.sub_string) ? item[element.key] : '' }}">{{
    get_value() }}</span>

<span *ngIf="element.type == 'timestamp'" class="{{ element.class }}">
    {{
    (element.conditions_index == null || element.conditions_index == "") ? timestamp_to_date_format(item[element.key]) :
    ((item[element.conditions_index] == element.condition_value) ? timestamp_to_date_format(item[element.key]) : "---" )
    }}
</span>

<span *ngIf="element.type == 'date'" class="{{ element.class }}">{{ date_format(item[element.key],"date")
    }}</span>

<span *ngIf="element.type == 'datetime'" class="{{ element.class }}">{{ date_format(item[element.key])
    }}</span>

<span *ngIf="element.type == 'boolean' && item[element.key] == true"
    class="{{ element.list[0].class }} font-weight-bold">{{
    element.list[0].text }}</span>
<span *ngIf="element.type == 'boolean' && item[element.key] == false"
    class="{{ element.list[1].class }} font-weight-bold">{{
    element.list[1].text }}</span>

<span *ngIf="element.type == 'enum-text'" class="{{ element.class[item[element.key]] }}">{{
    element.text[item[element.key]] }}</span>

<span *ngIf="element.type == 'enum' && !element.hasOwnProperty('onChange')"
    class="{{ element.class[item[element.key]] }}">{{
    element.text[item[element.key]] }}</span>
<select class="form-control" *ngIf="element.type == 'enum' && element.hasOwnProperty('onChange')"
    (change)="element.onChange(item.id ,$event)" [(ngModel)]="item[element.key]">
    <option value="{{ item.value }}" *ngFor="let item of element.list">{{ item.text }}</option>
</select>

<a href="javascript:void(0)" class="avatar rounded-circle mx-3" *ngIf="element.type == 'image'">
    <img alt="Image placeholder" src="{{ item[element.key] }}" style="height: 100%;object-fit: cover;">
</a>
<label class="switch" *ngIf="element.type == 'switch'">
    <input type="checkbox" [(ngModel)]="item[element.key]" (change)="element.onChange(item.id,item[element.key])">
    <span class="slider round"></span>
</label>

<div class="d-flex align-items-center" *ngIf="element.type == 'progress-bar'">
    <span class="mr-2">{{ item[element.key] }}%</span>
    <div>
        <div class="progress">
            <div class="progress-bar {{ (width == 100) ? 'bg-success' : 'bg-warning' }}" role="progressbar"
                aria-valuenow="{{ item[element.key] }}" aria-valuemin="0" aria-valuemax="100"
                [ngStyle]="setWidth(item[element.key])"></div>
        </div>
    </div>
</div>

<div [innerHTML]="item[element.key]" *ngIf="element.type == 'html'"></div>

<div *ngIf="element.type == 'check'" [innerHTML]="get_value_check()"></div>

<div *ngIf="element.type == 'list'">
    <div *ngFor="let itemList of item[element.key]">
        <span class="{{ element.class }} font-weight-bold">{{ itemList[element.text] }}</span>
        <br>
    </div>
    <span class="font-weight-bold" *ngIf=" item[element.key].length == 0">---</span>
</div>

<div *ngIf="element.type == 'relation-list-with-filter'">
    <div *ngFor="let itemList of item[element.key]">
        <span style="cursor: pointer !important;" class="{{ element.class }} font-weight-bold" (click)="go_to_route_relation_list_with_filter(itemList)">{{ get_value_relation_list_with_filter(itemList) }}</span>
        <br>
    </div>
    <span class="font-weight-bold" *ngIf=" item[element.key].length == 0">---</span>
</div>

<div *ngIf="element.type == 'card'" [innerHTML]="get_card_value()"></div>